import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { MENU_CONTENT_TYPES } from './consts';
import { CONTENT_MAPPING } from './content';

const MenuContent = ({
    id,
    data,
    showClearAll,
    showApply,
    contentType,
    additionalProps,
    applyFilters,
    clearAll,
    contentRef,
    isValidFilter,
    setIsValidFilter,
    closeMenu,
    preventCloseAction,
    maxMenuHeight,
    usePillButton,
}) => {
    const isCheckboxList = contentType === MENU_CONTENT_TYPES.CHECKBOX_LIST;
    const [selected, setSelected] = useState(isCheckboxList ? [] : '');
    const Content = CONTENT_MAPPING[contentType] || CONTENT_MAPPING[MENU_CONTENT_TYPES.CHECKBOX_LIST];

    const isBudget = contentType === MENU_CONTENT_TYPES.BUDGET;
    const shouldAddButtonGap = isBudget;

    const onSelect = (value) => {
        if (isCheckboxList) {
            const { item, checked } = value;

            setSelected((prevSelected) =>
                checked ? [...prevSelected, item.id] : prevSelected.filter((id) => id !== item.id)
            );
            return;
        }

        setSelected(value);
    };

    const onClear = () => {
        setSelected(isCheckboxList ? [] : '');
    };

    const handleApplyFilters = () => {
        if (isValidFilter) {
            applyFilters();
        }
    };

    useEffect(() => {
        if (contentType === MENU_CONTENT_TYPES.RADIO_LIST) {
            setSelected(data.filter((item) => item.selected).map((item) => item.id)[0]);
        }

        if (isCheckboxList) {
            setSelected(data.filter((item) => item.selected).map((item) => item.id));
        }
    }, [contentType, data, isCheckboxList]);

    return (
        <div ref={preventCloseAction} className="menu-content">
            <div
                className="content-scroll"
                style={
                    usePillButton && isBudget
                        ? { maxHeight: `${maxMenuHeight}px`, width: '250px', padding: '20px', overflowY: 'auto' }
                        : { maxHeight: `${maxMenuHeight}px` }
                }
            >
                <Content
                    id={id}
                    items={data}
                    ref={contentRef}
                    applyFilters={applyFilters}
                    selected={selected}
                    onSelect={onSelect}
                    onClear={onClear}
                    visibleCheckboxListItems={4}
                    setIsValidFilter={setIsValidFilter}
                    closeMenu={closeMenu}
                    {...additionalProps}
                />
            </div>

            {(showApply || showClearAll) && (
                <div className={classNames('button-row', { 'btn-wide-gap': shouldAddButtonGap })}>
                    {showClearAll && (
                        <Button
                            size="lg"
                            variant="ghost"
                            className="clear-all"
                            color={isValidFilter ? 'grey_1000' : 'grey_800'}
                            onClick={clearAll}
                            disabled={!isValidFilter}
                        >
                            <I18n k="search_perseus.general.clear_all" />
                        </Button>
                    )}
                    {showApply && (
                        <Button
                            size="lg"
                            className="apply"
                            color="white"
                            onClick={handleApplyFilters}
                            disabled={!isValidFilter}
                        >
                            <I18n k="search_perseus.general.apply" />
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default MenuContent;
